import React, { useState } from 'react';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';
import * as CoreActions from '../../actions/coreActions';
import * as UiActions from '../../actions/uiActions';

import classes from './TableRowMenu.module.css';

const TechnicianTableRowMenu = ({
    technician,
    deleteTechnician,
    openDeleteTechnicianModal,
    updateTechnician,
    toggleLoading,
    setProgressBarLoading,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleDeleteTechnician() {
        openDeleteTechnicianModal();

        handleClose();
    }

    async function handleTechnicianToggle(status) {

        const body = {
            isActive: !status,
            id:       technician.id
        };

        setProgressBarLoading(true);

        handleClose();

        await updateTechnician(body);

        setProgressBarLoading(false);
    }

    const renderActivationButtons = () => {
        if (technician.isActive) {
            return (
                <MenuItem onClick={() => handleTechnicianToggle(technician.isActive)}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/switchDisabledIconColor.svg"
                    />
                    Deactivate Technician
                </MenuItem>
            );
        }

        return (
            <MenuItem onClick={() => handleTechnicianToggle(technician.isActive)}>
                <img
                    alt=""
                    className={classes.contextIcon}
                    src="/assets/images/switchEnabledIconColor.svg"
                />
                Activate Technician
            </MenuItem>
        );
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleDeleteTechnician}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete Technician
                </MenuItem>
                {renderActivationButtons()}
            </Menu>
        </React.Fragment>
    );
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...CoreActions,
    ...UiActions
};

export default connect(null, mapDispatchToProps)(TechnicianTableRowMenu);
